import { Link } from 'react-router-dom';
import { colors, gradients, shadows } from '../styles/theme';

/**
 * Public maintenance landing page. Reached when:
 *   1. The force-logout effect fires at T=0 of a scheduled window.
 *   2. The user navigates to /maintenance directly during downtime.
 *
 * Public route (no auth) so users who were logged out can land here
 * without being bounced to /login. Mirrors the navy/gold brand of the
 * auth screens to preserve trust during an outage.
 */
const Maintenance = (): JSX.Element => {
  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ background: gradients.navy }}
    >
      <div
        className="w-full max-w-lg rounded-2xl p-10 text-center"
        style={{ background: colors.surface, boxShadow: shadows.card }}
      >
        <div
          className="mx-auto mb-6 w-14 h-14 rounded-2xl flex items-center justify-center font-black text-base"
          style={{
            background: gradients.gold,
            color: colors.navy,
          }}
        >
          QMI
        </div>

        <h1 className="text-2xl font-bold mb-3" style={{ color: colors.ink }}>
          Scheduled maintenance in progress
        </h1>
        <p className="text-sm leading-relaxed mb-6" style={{ color: colors.inkSoft }}>
          We&apos;re performing planned maintenance to keep the QMI Investor
          Portal secure and reliable. Service will resume automatically
          when the work is complete — no action is required on your part.
        </p>

        <div
          className="text-xs px-4 py-3 rounded-lg mb-8 text-left"
          style={{
            background: colors.canvas,
            border: `1px solid ${colors.border}`,
            color: colors.inkSoft,
          }}
        >
          <p className="font-semibold mb-1" style={{ color: colors.ink }}>
            What this means
          </p>
          <ul className="list-disc pl-4 space-y-1">
            <li>Sign-in is temporarily unavailable.</li>
            <li>Any in-flight transactions remain queued and intact.</li>
            <li>You&apos;ll be able to sign in again once we&apos;re done.</li>
          </ul>
        </div>

        <Link
          to="/login"
          className="inline-block px-5 py-2.5 rounded-xl text-sm font-semibold transition-all"
          style={{
            background: gradients.gold,
            color: colors.navy,
            boxShadow: shadows.goldCta,
          }}
        >
          Try signing in again
        </Link>

        <p className="mt-8 text-xs" style={{ color: colors.muted }}>
          Need help? <Link to="/contact" style={{ color: colors.gold }} className="underline underline-offset-2">Contact us</Link>
        </p>
      </div>
    </div>
  );
};

export default Maintenance;
